import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

const config = {
    name: 'calendar',
    actions: [
        { type: 'request', name: 'getAll' },
        { type: 'request', name: 'getOne' },
        { type: 'request', name: 'create' },
        { type: 'request', name: 'edit' },
        { type: 'request', name: 'delete' }
    ],
    endpoints: {
        events: '/events',
        event: '/events/[id]'
    }
}

const Config = {
    Actions: ModuleBootstrapper.getActions(config.name, config.actions),
    Endpoints: config.endpoints,
    ...ModuleBootstrapper.getUtils(),
}

export default Config;
